export default "__VITE_ASSET__68ut0HLL__"